<div class="modal-header">
    <h3 class="modal-title" id="modal-title" translate="PACE_PARTNER_ZGID_ERROR_TITLE"></h3>
</div>
<div class="modal-body">
    <p class="user-select-auto" translate="PACE_PARTNER_ZGID_ERROR_BODY"></p>
</div>
@if (!!paceTarget) {
    <div class="modal-footer">
        <button class="btn btn-primary" type="button" (click)="openInternalPace()">
            <span class="m-2" translate="PACE_PARTNER_ZGID_ERROR_BUTTON"></span>
            <fa-icon [icon]="faExternalLink"></fa-icon>
        </button>
    </div>
}
